var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaveLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49 2.214h2.5v3.711h1.495v2.177H3.99v7.918h-2.5V8.102H.191V5.925h1.3V2.214z",
    fill: "#6749A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49 2.214h2.5v3.711h1.495v2.177H3.99v7.918h-2.5V8.102H.191V5.925h1.3V2.214z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.692 5.926h-2.5v1.113a4.63 4.63 0 00-1.465-1.02 4.254 4.254 0 00-1.695-.34c-1.308 0-2.42.496-3.335 1.49-.916.993-1.373 2.268-1.373 3.823 0 1.499.473 2.753 1.419 3.762.946 1.01 2.066 1.514 3.362 1.514.577 0 1.113-.104 1.608-.31.494-.207.987-.545 1.479-1.014v1.076h2.5V5.926zM9.599 8.832c.517-.552 1.166-.828 1.947-.828.8 0 1.46.271 1.984.814.523.543.784 1.252.784 2.127 0 .894-.261 1.617-.784 2.17-.523.551-1.181.827-1.975.827-.769 0-1.416-.28-1.942-.842-.526-.56-.789-1.276-.789-2.146 0-.863.258-1.57.775-2.122z",
    fill: "#6749A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.192 5.926h2.5V16.02h-2.5v-1.076c-.492.469-.985.807-1.479 1.013-.495.207-1.03.31-1.608.31-1.296 0-2.416-.504-3.362-1.513-.946-1.009-1.419-2.263-1.419-3.762 0-1.555.457-2.83 1.373-3.823.915-.994 2.027-1.49 3.335-1.49.601 0 1.166.113 1.695.34a4.63 4.63 0 011.465 1.02V5.926zm-2.646 2.078c-.781 0-1.43.276-1.947.828-.517.552-.775 1.26-.775 2.122 0 .87.263 1.585.789 2.146a2.556 2.556 0 001.942.842c.794 0 1.452-.276 1.975-.828.523-.552.784-1.275.784-2.169 0-.875-.261-1.584-.784-2.127-.523-.543-1.184-.814-1.984-.814z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.137 5.925H20.7l2.51 5.957 2.535-5.957h2.537L23.987 16.02H22.39L18.137 5.925",
    fill: "#6749A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.137 5.925H20.7l2.51 5.957 2.535-5.957h2.537L23.987 16.02H22.39L18.137 5.925z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.72 11.69h8.054l.009-.48c0-1.662-.494-3-1.48-4.012-.985-1.013-2.265-1.52-3.839-1.52-1.482 0-2.714.508-3.697 1.523-.983 1.015-1.474 2.291-1.474 3.828 0 1.5.492 2.747 1.476 3.744.984.996 2.26 1.495 3.825 1.495 1.008 0 1.88-.182 2.613-.543.734-.362 1.364-.92 1.89-1.676l-2.108-1.002c-.672.663-1.476.994-2.41.994-.783 0-1.425-.212-1.93-.636-.504-.425-.814-.996-.93-1.715zm4.582-3.336c.488.349.815.8.98 1.357h-5.44c.282-.617.589-1.048.92-1.293.528-.391 1.142-.587 1.842-.587.644 0 1.21.174 1.698.523z",
    fill: "#6749A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.774 11.69h-8.055c.116.72.426 1.29.93 1.715.505.424 1.147.636 1.93.636.934 0 1.738-.331 2.41-.994l2.108 1.002c-.526.755-1.156 1.314-1.89 1.676-.733.361-1.605.543-2.613.543-1.566 0-2.84-.499-3.825-1.495-.984-.997-1.476-2.245-1.476-3.744 0-1.537.491-2.813 1.474-3.828.983-1.015 2.215-1.523 3.697-1.523 1.574 0 2.854.507 3.84 1.52.985 1.012 1.479 2.35 1.479 4.012l-.01.48zm-2.491-1.979a2.515 2.515 0 00-.98-1.357c-.489-.349-1.055-.523-1.7-.523-.699 0-1.313.196-1.84.587-.332.245-.639.676-.921 1.293h5.44z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.324 4.534c0-2.37.818-4.156 4.337-4.156-.021 2.91-1.566 4.198-4.337 4.156z",
    fill: "#6749A7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.324 4.534c0-2.37.818-4.156 4.337-4.156-.021 2.91-1.566 4.198-4.337 4.156z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaveLogo);
export default __webpack_public_path__ + "static/media/tave-logo.27a7de868734d07addf8150be974dbab.svg";
export { ForwardRef as ReactComponent };